import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import DeleteModal from "../../../../components/Common/DeleteModal";
import { usePagination } from "../../../../hooks/usePagination";
import ResultHandler from "../../../../components/ResultHandler";
import PaginationHandler from "../../../../components/PaginationHandler";
import { deletePool, getPools } from "../../../../api/pools";
import TableHeaderHandler from "../../../../components/TableHeaderHandler";
import { useTranslation } from "react-i18next";
import { useResponse } from "../../../../hooks/useResponse";
import TableAction from "../../../../components/TableAction";
import EmptyData from "../../../../components/EmptyData";
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { Button } from "reactstrap";

export default function PoolsTable() {
  const { t } = useTranslation();
  let navigate = useHistory();

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getPools);

  //// delete
  const [show, setShow] = useState(false);

  function onCloseClick() {
    setShow(false);
  }

  const [deletingPool, setDeletingPool] = useState(null);

  const { setData } = useResponse(deletePool, () => {
    setShow(false);
    setDeletingPool(null);
    setPayload({});
  });

  function onDeleteClick() {
    setData({ type: "add", data: deletingPool });
  }

  ///////////

  const [importModalOpen, setImportModalOpen] = useState(false);

  return (
    <>
      <TableHeaderHandler
        setPage={setPage}
        setPerPage={setPerPage}
        permission={PERMISSIONS.POULE_CREATE}
        addUrl="add-pool/noId"
      >
        {/*<div style={{marginRight: "15px"}}>
        <Button onClick={() => setImportModalOpen(true)} color="info">Import</Button>
  </div>*/}
      </TableHeaderHandler>

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Parent</Th>
                <Th>Company</Th>
                <Th>Contract</Th>
                <Th>Number of Employees</Th>
                <Th>Hours</Th>
                <Th style={{ width: "15%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.pools.map((row) => {
                  return (
                    <Tr key={row.id}>
                      <Td
                      // style={{ cursor: "pointer" }}
                      // onClick={() => navigate.push("/pool/" + row.id)}
                      >
                        {row.name}
                      </Td>
                      <Td>{row.parent?.name || "-"}</Td>
                      <Td>{row.companyContract?.company?.name}</Td>
                      <Td>{row.companyContract?.jobTitle}</Td>
                      <Td>{row.employees.length}</Td>
                      <Td>
                        <Button style={{marginLeft: "5px"}} color="dark" onClick={() => navigate.push('pool-hours/'+row.id)}>
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.POULE_EDIT}
                          type="pool"
                          id={row.id}
                        />
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.pools.length === 0}
              msg="No Pools Found."
            />
          )}
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {/*<ImportModal 
          fileName="erp_import_pools_template.xlsx"
          isOpen={importModalOpen} 
          onCloseClick={() => {setImportModalOpen(false)}} 
          api={importPools}
           handleRefresh={() => setPayload({refresh: true})}
        />*/}

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  );
}
